// Port of api/fuel/app/classes/filter/lists.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var Lists = Filter.extend({
	filter_type: F.TYPE_LISTS,
	cache_type: F.CACHE_LISTS,
	result_type: F.RESULT_LIST,
	pseudo_type: F.PSEUDO_LIST,
	json_package: 'lists',
	package_types: [F.PACKAGE_LIST]
})

export default Lists
